<template>
  <v-container class="px-5 d-flex align-center justify-center" style="height: 95vh" fluid>
    <div>
      <v-row class="my-7" align="center" justify="center">
        <PriorityFeaturesList :features="priorityFeatures"/>
      </v-row>
    </div>
  </v-container>
</template>

<script>
// import Repository from '../../repositories/analytics';
import PriorityFeaturesList from './components/PriorityFeaturesList'
export default {
  name: "Backlog",
  components: { PriorityFeaturesList },
  data() {
    return {
      priorityFeatures: [
        {
          name: 'Telegram Multilanguage',
          description: 'Telegram notifications available in multiple languages (English, Spanish, Portuguese).',
          status: 'Developing'
        },
        {
          name: 'Trading Room',
          description: 'Create worldwide livestreams for your community with just a click.',
          status: 'Developing'
        },
        {
          name: 'Tournament Landing',
          description: 'Get a landing of your Tournament to share and monetize it',
          status: 'Planning'
        },
        {
          name: 'Trading World Cup',
          description: 'Tournament for talented communities and academies in a World Cup View.',
          status: 'Planning'
        },
        {
          name: 'Back Office',
          description: 'Back office for fund managers. Ready to see aggregated analitycs.',
          status: 'Planning'
        },
        {
          name: 'Swiset Score',
          description: 'Measure your performance as a trader with the worlwide community.',
          status: 'Planning'
        },
      ],
      requirements: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // Repository.allFeatures();
    },
  }
}
</script>

<style scoped>

</style>
